<template>
  <NuxtLayout name="default" class="theme-trib">
    <PageBlocks
      v-if="page"
      :content="page.blocks"
      :error="error"
      class="app-width-large"
    >
      <template #header>
        <BlocksHeadersHeaderHero
          :title="edito.title"
          :hero="edito.cover"
          :detail="{
            auteur: edito.author ? edito.author.name : null,
            date: edito.published ? edito.published : null,
          }"
        />
      </template>

      <template #footer>
        <Share
          :title="edito.title"
          :description="edito.title"
          class="app-gutter-mobile-only app-width-small"
        />

        <template v-if="edito?.tags?.length">
          <div class="taglist app-width-small">
            <UiTag
              v-for="tag in edito.tags"
              :key="tag.id"
              :label="tag.label"
              :href="`${tagRootPath}?filter=${tag.slug}`"
            />
          </div>
        </template>

        <template v-if="edito?.related?.length">
          <UiTitleArrow :level="3" :content="'Poursuivre la lecture'" class="app-gutter" />
          <Related :items="edito.related" />
        </template>
      </template>
    </PageBlocks>
  </NuxtLayout>
</template>

<script setup>
import { getEditoFromData } from '~/data/edito';
definePageMeta({ layout: false });

const route = useRoute();
const { error, page, data } = await useFetchByPath(route.path);
const tagRootPath = route?.matched?.[0]?.path;

/* here page specifics */
const edito = getEditoFromData(data.data);
</script>

<style lang="stylus" scoped>
.taglist {
  display flex
  gap 15px
  justify-content center
  margin-top 50px
  margin-bottom 100px
}
</style>
